import { IGenerateOTP, IOTPLogin, ISignInResponse, IForgotPassword, ISSOLogin } from '../models/auth.model'
import axiosInstance from '../utils/api-util/utilApi'

export const checkAccountValid = (payload: IOTPLogin): Promise<any> => axiosInstance.post(`/checkAccountValid`, payload)

export const forgotPassword = (payload: IForgotPassword): Promise<any> => axiosInstance.post(`/forgotPassword`, payload)

export const generateOTP = (payload: IGenerateOTP): Promise<any> => axiosInstance.post(`/generateOtp`, payload)

export const resendOTP = (payload: IGenerateOTP): Promise<any> => axiosInstance.post(`/resendOtp`, payload)

export const checkNewPasswordValid = (payload: any): Promise<any> =>
  axiosInstance.post(`/checkNewPasswordValid`, payload)

export const verifyEmailToken = (pathUrl: string): Promise<any> => axiosInstance.get(pathUrl)

export const getMe = (): Promise<any> => axiosInstance.get('/me')

export const resetPassword = (payload: any): Promise<any> => axiosInstance.post(`/resetPassword`, payload)

export const changePassword = (payload: any): Promise<any> => axiosInstance.post(`/changePassword`, payload)

export const signIn = (payload: IOTPLogin): Promise<ISignInResponse> => axiosInstance.post(`/login`, payload)

export const signOut = (): Promise<any> => axiosInstance.post(`/logout`)

export const renewToken = (payload: any): Promise<ISignInResponse> =>
  fetch(`${process.env.REACT_APP_BASE_URL}/refreshToken`, {
    method: 'POST',
    body: `"${payload}"`,
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())

export const ssoLogin = (payload: ISSOLogin): Promise<any> => axiosInstance.post(`/ssoLogin`, payload)
